import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './IdogcamCameraTypeCard.module.scss';

interface IdogcamCameraTypeCardProps {
    icon: IconDefinition;
    title: string;
    description: string;
    selected: boolean;
    onSelect: () => void;
}

export const IdogcamCameraTypeCard: FunctionComponent<IdogcamCameraTypeCardProps> = props => (
    <button
        type="button"
        role="radio"
        aria-checked={props.selected}
        className={clsx(styles.card, { [styles.selected]: props.selected })}
        onClick={props.onSelect}
    >
        <FontAwesomeIcon
            icon={props.icon}
            className={styles.icon}
        />
        <span className={styles.texts}>
            <span className={styles.title}>{props.title}</span>
            <span className={styles.description}>{props.description}</span>
        </span>
        <FontAwesomeIcon
            icon={props.selected ? faCircleCheck : faCircle}
            className={clsx(styles.check, { [styles.checkSelected]: props.selected })}
        />
    </button>
);

export default IdogcamCameraTypeCard;
